import React from "react";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import DatasetCard from "./dataset-card";

const CategorySection = ({
                             group,
                             groupTitle,
                             options,
                             resolveEntry,
                             expandedId,
                             onExpand,
                             onSelect,
                         }) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.settingsImport.dataSourceCatalog'});
    const categoryLabel = t(`categories.${group}`, {defaultValue: groupTitle});

    return (
        <Box
            component="section"
            sx={{mb: 3}}
            id={`import-catalog-category-${group}`}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    mb: 1.5,
                    px: 0.25,
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        fontWeight: 700,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        lineHeight: 1.2,
                    }}
                >
                    {categoryLabel}
                </Typography>
                <Typography
                    component="span"
                    variant="caption"
                    sx={{
                        color: 'primary.main',
                        fontWeight: 700,
                        lineHeight: 1.2,
                    }}
                >
                    · {t('categoryCount', {count: options.length})}
                </Typography>
            </Box>
            {options.map((option) => {
                const entry = resolveEntry(option);
                return (
                    <DatasetCard
                        key={`${group}-${option.id}`}
                        entry={entry}
                        option={option}
                        expanded={expandedId === option.id}
                        onExpand={onExpand}
                        onSelect={onSelect}
                    />
                );
            })}
        </Box>
    );
};

export default CategorySection;
